import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { Header } from 'layouts/SignUpTemplate/components/Header';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Form } from './Form';
import { Success } from './Success';

interface PromptStage {
  stage: 'prompt';
}
interface SuccessStage {
  stage: 'success';
}
type State = PromptStage | SuccessStage;

export const ResetPassword: React.FC = () => {
  const [state, setState] = React.useState<State>({ stage: 'prompt' });
  const [searchParams] = useSearchParams();
  const revoked = searchParams.get('revoked');

  let content;
  switch (state.stage) {
    case 'success':
      content = <Success />;
      break;
    case 'prompt':
    default:
      content = <Form onSuccess={() => setState({ stage: 'success' })} />;
      break;
  }

  const header = revoked
    ? 'Your account has been removed from your company'
    : 'Reset your password';

  const subheader = revoked
    ? 'Please reset your password to continue. You will have to create a new company account afterwards.'
    : "Enter the email address for your account and we'll send you a temporary link to reset your password.";

  return (
    <SignUpTemplate>
      <div className="flex items-center flex-col space-y-16">
        <Header header={header} subHeader={subheader} />
        {content}
      </div>
    </SignUpTemplate>
  );
};
